// Libs
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";

export default function EmergencyOrderModal(props) {
  // State
  const [date, setDate] = useState(moment());

  return (
    <Modal show={props.show}>
      <Modal.Header>
        <Modal.Title>Please select a date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type="date"
          value={date.format("YYYY-MM-DD")}
          onChange={(e) => setDate(moment(e.target.value, "YYYY-MM-DD"))}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={() => props.hide(date)}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
